import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

export interface ConditionalRouteProps extends RouteProps {
  component: React.ComponentType<object>;
  isConditionSatisfied?: boolean;
  config: {
    redirectTo: string;
  };
}

const ConditionalRoute = ({
  component: Component,
  isConditionSatisfied,
  config: { redirectTo },
  ...rest
}: ConditionalRouteProps) => (
  <Route
    {...rest}
    render={(props) =>
      isConditionSatisfied ? (
        <Component {...props} />
      ) : (
        <Redirect to={redirectTo} />
      )
    }
  />
);

export default ConditionalRoute;
